export const types = {
	ADD_DOCUMENT: "ADD_REGISTRATION_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_REGISTRATION_DOCUMENT",
	INIT_DOCUMENTS: "INIT_REGISTRATION_DOCUMENTS",
	RESET_DOCUMENTS: "RESET_REGISTRATION_DOCUMENTS",
}

export const addRegistrationDoc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}
export const initRegistrationDocs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const removeRegistrationDoc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}
export const resetRegistrationDocs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}